import { defaultTransitionClass, nToPx, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const tabItemSelectedClass = style({
  fontWeight: themeVars.font.weight.bold,
});

export const tabItemClass = style([
  defaultTransitionClass,
  {
    position: 'relative',
    padding: nToPx(0, 0, themeVars.space.x3),
    fontSize: themeVars.font.size.textMd,
    cursor: 'pointer',
    height: 32,
    minWidth: 70,
    textAlign: 'center',

    selectors: {
      [`&:hover&:not(${tabItemSelectedClass})`]: {
        textDecoration: 'underline',
      },
    },
  },
]);

export const underlineBorderClass = style([
  defaultTransitionClass,
  {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: themeVars.colors.neutrals.grey50,
    height: 6,
  },
]);

export const underlineBorderFirstItemClass = style({
  borderRadius: nToPx(themeVars.radius.sm, 0, 0, themeVars.radius.sm),
});
export const underlineBorderLastItemClass = style({
  borderRadius: nToPx(0, themeVars.radius.sm, themeVars.radius.sm, 0),
});

export const underlineBorderSelectedClass = style({
  backgroundColor: themeVars.colors.components.tabs.selected,
});
